import { defineComponent as _defineComponent } from 'vue'
import { normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

import ChatMessageContent from "@/components/chat/chatContainer/ChatMessageContent/ChatMessageContent.vue";
import ChatMessageSender from "@/components/chat/chatContainer/ChatMessageSender/ChatMessageSender.vue";
import { AudioMessage, Message } from "@/store/chats/types";
import AudioMessagePlayer from "../AudioMessagePlayer/AudioMessagePlayer.vue";
import { useComputedValue } from "@/composables";
import { GetterTypes } from "@/store";
import { computed } from "vue";
import DeletedMessage from "../DeletedMessage/DeletedMessage.vue";

interface ChatMessageProps {
  message: AudioMessage;
  index: number;
  visibleMessages: Message[];
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ChatAudioMessage',
  props: {
    message: {},
    index: {},
    visibleMessages: {}
  },
  setup(__props: any) {

const props = __props;
const authId = useComputedValue<number>(GetterTypes.GET_AUTH_ID);
const isMine = computed(() => props.message.senderId === authId.value);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ChatMessageContent, {
    index: _ctx.index,
    message: _ctx.message,
    "visible-messages": _ctx.visibleMessages
  }, {
    default: _withCtx(() => [
      _createVNode(ChatMessageSender, _normalizeProps(_guardReactiveProps(props)), null, 16),
      (_ctx.message.isDeleted)
        ? (_openBlock(), _createBlock(DeletedMessage, {
            key: 0,
            "is-mine": isMine.value,
            "message-type": _ctx.message.type
          }, null, 8, ["is-mine", "message-type"]))
        : (_openBlock(), _createBlock(AudioMessagePlayer, {
            key: 1,
            message: _ctx.message
          }, null, 8, ["message"]))
    ]),
    _: 1
  }, 8, ["index", "message", "visible-messages"]))
}
}

})